const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isValidUuid(value: string | undefined | null): value is string {
  return typeof value === 'string' && UUID_RE.test(value)
}

export function shortenUuid(uuid: string): string {
  const stripped = uuid.replace(/-/g, '')
  if (stripped.length < 10) return uuid
  return `${stripped.slice(0, 5)}***${stripped.slice(-5)}`
}

// crypto.randomUUID 仅在 Secure Context(HTTPS / localhost / 127.0.0.1 / file://)下暴露;
// L4 手测从局域网 IP(http://192.168.x.x)访问 SPA 时非 secure context → 方法 undefined。
// 这里给纯 client-side 的 task id / idempotency_key 用,不用作密码学随机。
export function randomUUID(): string {
  const c = globalThis.crypto as Crypto | undefined
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID()
  }
  const hex = '0123456789abcdef'
  let out = ''
  for (let i = 0; i < 36; i++) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      out += '-'
    } else if (i === 14) {
      out += '4'
    } else if (i === 19) {
      out += hex[8 + Math.floor(Math.random() * 4)]
    } else {
      out += hex[Math.floor(Math.random() * 16)]
    }
  }
  return out
}
